export const STATUS_CLASSNAMES = {
  0: 'status-3',
  1: 'status-2',
  2: 'status-1'
};
